<template>
  <div class="about">
    <!-- <h1>Registered pilots</h1> -->
    <v-container fluid>
      <!-- <p>{{ radio || "null" }}</p> -->
      <v-radio-group v-model="radio" row mandatory @change="radiochanged" dense>
        <v-radio label="Cards" value="Cards"></v-radio>
        <v-radio label="List" value="List"></v-radio>

        <v-radio label="Table" value="Table"></v-radio>
      </v-radio-group>
    </v-container>

    <div v-if="radionumber == 2">
      <BoxesByList :items="items" :loading="loading"></BoxesByList>
    </div>
    <div v-if="radionumber == 1">
      <BoxCard :items="items" :loading="loading" :loggedIn="loggedIn"></BoxCard>
    </div>
    <div v-if="radionumber == 3">
      <BoxTable :items="items" :loading="loading"></BoxTable>
    </div>

    <br />
    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color: Red">
        {{ error.message }}
      </li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import BoxTable from "@/components/airbox/BoxTable.vue";
import BoxCard from "@/components/airbox/BoxCard.vue";
import BoxesByList from "@/components/airbox/BoxesByList.vue";

export default {
  name: "Lsb",
  data() {
    return {
      loading: true,
      items: [],
      errors: [],
      radio: null,
      radionumber: Number,
      cookieToken: Number,
      cookieRegId: Number,
      loggedIn: false,
      getCookies() {
        this.cookieRegId = this.$cookies.get("pgbregid");
        this.cookieToken = this.$cookies.get("pgbtoken");
        if (this.cookieToken > 0) {
          this.loggedIn = true;
        }
        // console.log("LoggedIn",this.loggedIn)
      },
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedBoxText = null;
    axios
      // .get("http://jsonplaceholder.typicode.com/posts")
      //   .get("http://localhost:3000/dbapi/events")
      .get(this.baseUrl + "events")
      .then((response) => {
        // JSON responses are automatically parsed.
        this.items = response.data;
        this.loading = false;
      })
      .catch((e) => {
        this.errors.push(e);
      });
    this.radionumber = 1;
    this.getCookies();
    // this.getEventOpeners(1);
  },
  methods: {
    radiochanged() {
      if (this.radio == "List") {
        this.radionumber = 2;
      }
      if (this.radio == "Cards") {
        this.radionumber = 1;
      }
      if (this.radio == "Table") {
        this.radionumber = 3;
      }
    },
  },
  components: {
    BoxTable,
    BoxCard,
    BoxesByList,
  },
};
</script>
